/// <amd-module name="Dashboards/CommonConfig/SizePicker" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { CombinedSizePicker } from "./CombinedSizePicker";
import { SeparatedSizePicker } from "./SeparatedSizePicker";
import { SizePickerProps } from "./SizePicker.props";
import { getSizeOptionsMap, hasRectangularOptionsSet } from "./SizePickerHelpers";

interface SizePickerState {
    widthToHeightsMap: { [key: string]: string[] };
    shouldRenderSplitPickers: boolean;
}

/**
 *  A size picker factored for reuse with Widget Confuration experiences and legacy Widget Host.
 * */
export class SizePicker extends VssComponent<SizePickerProps, SizePickerState> {
    constructor(props: SizePickerProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { widthToHeightsMap: {}, shouldRenderSplitPickers: false };
    }

    public componentDidMount() {
        const widthToHeightsMap = getSizeOptionsMap(this.props.sizes);
        this.setState({ widthToHeightsMap, shouldRenderSplitPickers: hasRectangularOptionsSet(widthToHeightsMap) });
    }

    public render(): JSX.Element {
        return (
            <>
                {this.state.shouldRenderSplitPickers ? (
                    <SeparatedSizePicker {...this.props} widthToHeightsMap={this.state.widthToHeightsMap} />
                ) : (
                    <CombinedSizePicker {...this.props} />
                )}
            </>
        );
    }
}
